// extracted by mini-css-extract-plugin
module.exports = {"name":"Buscamos_name__2TPK2","image":"Buscamos_image__1frIX"};